module.exports = "/_next/static/images/CompanyMission-8c51a0c9d380d7360cae1957cd680585.jpg.webp";